// Below 992px the form's three columns become tabs, one shown at a time
export const MOBILE_TAB_QUERY = '(max-width: 991.98px)';

// The Song Info fields, so a blocked save can point at the tab holding the reason
export const SONG_INFO_FIELDS = [
  'title',
  'artist',
  'key',
  'transposeToKey',
  'bpm',
  'timeSignature',
  'categoryId',
  'themes',
  'youtube',
];

/**
 * A new song opens on Info, since it can't be saved without it. A part opened from the song view
 * opens on Lyrics; any other edit opens on Parts, as a song's info is rarely touched after it's made.
 */
export const startingTab = (isNewSong, search = '') => {
  if (isNewSong) return 'info';

  return new URLSearchParams(search).has('editPartId') ? 'lyrics' : 'parts';
};

/**
 * Which tabs get a dot: Info while one of its fields fails validation, Lyrics while a part is
 * open in the editor. Either one keeps Save disabled.
 */
export const tabsNeedingAttention = ({ validationErrors, editPartId }) => ({
  info: SONG_INFO_FIELDS.some((field) => validationErrors?.[field]),
  lyrics: !!editPartId,
});
